import { forwardRef } from 'react';

// Styles
import { Div } from './style';

export const LoadAnchor = forwardRef(
  ({ isLoading, visible = isLoading, ...props }, ref) => (
    <Div visible={visible} ref={ref} {...props} />
  )
);
